module.exports = __webpack_public_path__ + "static/media/bg_thinktool.46da064f.jpg";